import React, { useEffect, useState } from 'react';
import { WelcomeScreen } from './components/WelcomeScreen';
import { RFIDScanScreen } from './components/RFIDScanScreen';
import { MainScreen } from './components/MainScreen';
import { InspectionNotification } from './components/InspectionNotification';
export function App() {
  const [showWelcome, setShowWelcome] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationData, setNotificationData] = useState({
    orderName: '',
    minutesRemaining: 0
  });
  const handleWelcomeStart = () => {
    setShowWelcome(false);
  };
  const handleRFIDScan = (rfidCode: string) => {
    // In production, verify RFID against user database
    console.log('RFID scanned:', rfidCode);
    setIsLoggedIn(true);
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    setShowWelcome(true);
  };
  // Demo: Show notification after login
  useEffect(() => {
    if (isLoggedIn) {
      const timer = setTimeout(() => {
        setNotificationData({
          orderName: 'Hähnchenbrust Premium - Charge 12345',
          minutesRemaining: 2
        });
        setShowNotification(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isLoggedIn]);
  if (showWelcome) {
    return <WelcomeScreen onStart={handleWelcomeStart} data-id="element-0" />;
  }
  if (!isLoggedIn) {
    return <RFIDScanScreen onScan={handleRFIDScan} data-id="element-1" />;
  }
  return <>
      <MainScreen onLogout={handleLogout} data-id="element-2" />
      <InspectionNotification orderName={notificationData.orderName} minutesRemaining={notificationData.minutesRemaining} isVisible={showNotification} onClose={() => setShowNotification(false)} data-id="element-3" />
    </>;
}